<template>
  <!-- 电话咨询，律师介绍 -->
  <div class="telawint">
    <tellaintlcjis />
    <div class="w12 between mt30">
      <div class="lefcol">
        <div class="tuceng"></div>
        <div class="userin mt30 flex_start">
          <div class="usercove">
            <img src="../../assets/home/lvshi_lv_sample1.png" alt="" />
          </div>
          <div class="usertxt">
            <div class="ysername"><span>张三</span> 律师</div>
            <div class="ssls">安徽律观律师事务所</div>
            <div class="bzhq flex_start">
              <div class="mr20">已帮助：<span>12345</span>人</div>
              <div>获好评数：<span>1000</span> 次</div>
            </div>
            <div class="fwfy">
              服务费用：<span class="price"> ¥49</span> /20分钟
              <span class="beizhu">(超过90%的用户在10分钟内完成通话)</span>
            </div>
            <div class="dhbtn center">
              <svg-icon icon-class="dianhua" class="a" />电话咨询
            </div>
          </div>
        </div>
        <div class="lawint mt30 bgff">
          <div class="t2tbt">律师简介</div>
          <div class="jjnr">
            张三律师，中共党员，法学硕士，系安徽律观律师事务所主任、党支部书记、权益高级合伙人。张三律师团队大部分成员为离职法官、检察官，具备较高的法律素养，葛进律师执业多年，办理过各种疑难复杂案件，具有丰富的办案经验，团队分工合作，擅长领域为:刑事辩护、合同纠纷、拆迁诉讼、交通事故、医疗事故、房产纠纷、民间借贷、婚姻及继承纠纷、知识产权纠纷、股权纠纷等诉讼及非诉讼方面法律纠纷。始终坚持“敬业、高效、执着、奉献”的执业理念，长期为任合肥元一希尔顿酒店、安徽问舍地产商业有限公司、安徽浩琛生态农业开发有限公司、安徽运泰集团股份公司等多家企事业单位提供法律顾问方面的法律服务。张三律师成功办理过多起具有影响力的案件，如故意杀人罪刑事案件、行政机关违法行政案件、特大交通事故损害赔偿案、企业改制集体劳动争议案、股权争议谈判案、破产清算案、涉亿元经济合同纠纷案等等。我们的承诺：所有的疑难复杂案件均由专业团队研究确定处理方案，受人之托，忠人之事！联系电话：15566489112。律所地址：新华国际广场c座21楼安徽律观律师事务所。
          </div>
        </div>
        <div class="scly mt30 bgff">
          <div class="t2tbt">擅长领域</div>
          <div class="lylist flex_start wrap">
            <div class="lyitem" v-for="item in 10" :key="item">刑事辩护</div>
          </div>
        </div>
        <div class="dhlsss mt30 bgff">
          <div class="t2tbt">电话律师的收费真的贵么？</div>
          <div class="dhlsssnr">
            <p>
              去律师事务所见面咨询的费用：
              <span>交通费+误工费+咨询费+住宿费（外地用户）</span>
            </p>
            <p>
              可能花费了上面高昂的代价后，占用您大量的时间，换来的也只是15、20分钟的面询。
            </p>
            <p>
              您可以将这些费用如果和电话咨询律师的费用做比较，电话律师反而是一种帮您节省时间和费用的实惠业务，您可以在家选择您信任、专业的律师。
            </p>
          </div>
        </div>
      </div>
      <div class="rigcol">
        <!-- <div class="ys"></div> -->
        <div class="cjwt  bgff">
          <div class="t2tbt">常见问题</div>
          <div class="wtlist">
            <div class="wtitem" v-for="item in 3" :key="item">
              {{ item }}、电话咨询律师能给我提供什么？
            </div>
          </div>
        </div>
		
		<div class="consulting_skills">
			<div class="title FontSize20">
				电话咨询技巧
			</div>
			<div class="skillitem flex mt30">
				<div class="itemleft FontSize22 FontBlue">
					1
				</div>
				<div class="itemright FontSize16 FontWhite">
					请先想好问题的具体内容
				</div>
			</div>
			<div class="skillitem flex">
				<div class="itemleft FontSize22 FontBlue">
					2
				</div>
				<div class="itemright FontSize16 FontWhite">
					根据您的问题寻找合适的律师
				</div>
			</div>
			<div class="skillitem flex">
				<div class="itemleft FontSize22 FontBlue">
					3
				</div>
				<div class="itemright FontSize16 FontWhite">
					建议拨打时间 9:00~21:00
				</div>
			</div>
		</div>
		
		<div class="zixun flex-col center">
			<span class="tit">律观网</span>
			<span class="FontSize18">尽一切力量挽回你的合法权益</span>
			<div class="btn FontSize18 FontWhite">
				立即咨询
			</div>
			<div class="box">
				
			</div>
		</div>
		
      </div>
    </div>
    <section class="w_fluid"><teladv /></section>
  </div>
</template>

<script>
import tellaintlcjis from "./child/tellaintlcjis";
import teladv from "views/telzx/child/teladv"; //评价咨询
export default {
  components: {
    tellaintlcjis,
    teladv,
  },
};
</script>

<style lang="scss" scoped>
.telawint {
  background-color: #f8f8f8;
    padding-top:50px;
  .w12 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    align-items: flex-start;
    padding-bottom:30px;
    .bgff {
      background: #ffffff;
      box-shadow: 0px 2px 8px 0px rgba(1, 1, 1, 0.07);
    }
    .t2tbt {
      font-size: 24px;
      color: #333333;
    }
    .lefcol {
      width: 830px;
      .tuceng {
        width: 100%;
        height: 124px;
        background-image: url("~assets/entrust/ydytelzxtubg.png");
      }
      .userin {
        align-items: flex-start;
        padding: 25px 0;
        border-top: 1px solid #eee;
        .usercove {
          margin-right: 30px;
          img {
            width: 132px;
            height: 160px;
          }
        }
        .usertxt {
          .ysername {
            font-size: 16px;
            color: #aaaaaa;
            line-height: 26px;
            span {
              margin-right: 8px;
              font-size: 26px;
              color: #0465ea;
            }
          }
          .ssls {
            font-size: 14px;
            color: #333333;
            margin-top: 12px;
          }
          .bzhq {
            margin-top: 10px;
            font-size: 14px;
            color: #333333;
            span {
              color: #ec3a3a;
            }
          }
          .fwfy {
            margin-top: 10px;
            font-size: 14px;
            color: #333333;
            .price {
              color: #ff4646;
            }
            .beizhu {
              color: #aaaaaa;
            }
          }
          .dhbtn {
            cursor: pointer;
            margin-top: 10px;
            width: 120px;
            height: 30px;
            background: #ff4646;
            color: #ffffff;
            border-radius: 15px;
            .a {
              margin-right: 4px;
            }
          }
        }
      }
      .lawint {
        width: 100%;
        padding: 20px;
        .jjnr {
          margin-top: 16px;
          font-size: 16px;
          color: #666666;
          line-height: 30px;
        }
      }
      .scly {
        width: 100%;
        padding: 20px;
        .lylist {
          .lyitem {
            margin-top: 25px;
            width: 130px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background: #ffffff;
            border: 1px solid #666666;
            margin-right: 35px;
            font-size: 16px;
            color: #333333;
            &:nth-child(5n) {
              margin-right: 0;
            }
          }
        }
      }
      .dhlsss {
        width: 100%;
        padding: 20px;
        .dhlsssnr {
          margin-top: 20px;
          font-size: 16px;
          color: #555555;
          line-height: 34px;
          span {
            color: #0465ea;
          }
        }
      }
    }
    .rigcol {
      width: 340px;
      .ys {
        width: 100%;
        height: 124px;
        background-image: url("~assets/entrust/tdycbg.png");
      }
      .cjwt {
        width: 100%;
        padding: 20px;
        .wtlist {
          margin-top: 10px;
          .wtitem {
            cursor: pointer;
            font-size: 16px;
            color: #333333;
            line-height: 48px;
            &:hover {
              color: #0465ea;
            }
          }
        }
      }
    }
  }
  .w_fluid {
    width: 100%;
    background-color: #fff;
  }
}

.consulting_skills{
	margin: 30px 0;
	.title{
		border-left: 4px solid #0465EA;
		padding-left: 10px;
		margin-bottom:18px ;
	}
	.skillitem{
		width: 100%;
		height: 60px;
		text-align: center;
		line-height: 60px;
		margin-top: 12px;
		.itemleft{
			width: 15%;
			height: 100%;
			background-color: #EDF5FF;
		}
		.itemright{
			width: 85%;
			height: 100%;
			background-image: linear-gradient(to right ,#3c8bff,#44aeff,#3c8bff);
		}
	}
}
.zixun{
	width: 340px;
	height: 340px;
	background-image: url(../../assets/telzx/bg4.png);
	color: #666;
	position: relative;
	.tit{
		font-size: 38px;
		font-weight: 500;
		margin-bottom: 15px;
		
	}
	.btn{
		width: 100px;
		height: 32px;
		background: #FF8916;
		border-radius: 5px;
		text-align: center;
		margin-top: 25px;
	}
	.box{
		position: absolute;
		width: 80%;
		height:72px ;
		top: 115px;
		background: url(../../assets/telzx/line.png) center/contain no-repeat;
			
	}
}
</style>